import { API_DICTIONARY } from 'constants/api'
import {
  TCompleteRebatesPaymentData,
  TCompleteRebatesPaymentDataToSend
} from './types'
import { HTTP_METHODS } from 'constants/api'
import Fetcher from 'services/Fetcher'
import { TBankAccountsListResponse } from 'features/BankAccount/types'

const fetcher = new Fetcher({})

export const getCompleteRebatesPaymentData = async (
  rebate_quarter_id: string
) =>
  fetcher.request<unknown, TCompleteRebatesPaymentData>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.REBATES_DASHBOARD}${rebate_quarter_id}/${API_DICTIONARY.PAYMENT}${API_DICTIONARY.COMPLETE}`,
    method: HTTP_METHODS.GET
  })

export const fetchPaymentOptions = async (businessAccountId: string) =>
  fetcher.request<unknown, TBankAccountsListResponse>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${businessAccountId}/${API_DICTIONARY.BANK_ACCOUNTS}?purposes=receivable&statuses=verified&payment_method_type=ach-credit-standard&ordering=-is_default`,
    method: HTTP_METHODS.GET
  })

export const completeRebatesPayment = async (
  businessAccountId: string,
  data: TCompleteRebatesPaymentDataToSend
) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.REBATES_DASHBOARD}${businessAccountId}/${API_DICTIONARY.PAYMENT}${API_DICTIONARY.COMPLETE}`,
    method: HTTP_METHODS.POST,
    data
  })
